const data = {
    mainHeadding: "This page may not be the exact page you were looking for! It could be because GuideStar India has upgraded to a new platform with a lot more information and insights! We’ve redesigned and reorganised content to serve you better!",
    subHeadding: "Access our vast collection of verified NPO profiles, make choices backed by facts, engage with NPOs you can trust and support causes that resonate with your values!",
    MainSideImg: "../../../../public/Images/Frame 16.png",
    inputPlaceHolder: "Enter organisation name or keyword or GSN/PAN/Darpan ID/FCRA Number"
}
export { data }